module.exports = __webpack_public_path__ + "static/media/fantest_unis_2.78b4b0d9.png";